import React from 'react'
import ModalBox from '../../components/modal/ModalBox'
import { catchMessage, elseMessage, successMessage } from '../../comman/Message'
import { deleteFaqApi } from '../../services/faq'

const DeleteFaq = ({ show, close, status, id, listing, name }) => {

    const deleteFaq = async () => {
        try {
            const res = await deleteFaqApi(id)
            if (res?.data?.status === 200) {
                close()
                listing()
                successMessage(res)
            } else {
                elseMessage(res)
            }
        } catch (err) {
            catchMessage(err)
        }
    }
    return (
        <ModalBox
            status={show}
            onClose={close}
            title="Delete Faq"
            description={<span>Do you want to Delete <strong>{name}</strong> ?</span>}
            action={deleteFaq}
        />
    )
}

export default DeleteFaq